export default __webpack_public_path__ + "static/media/quotes-left.53246535.svg";